module.exports = __webpack_public_path__ + "static/about-32beef99c7484611ddd9f0b4b6db5534.png";